/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import { FiraSansBold } from 'components/Text';
import Colors from 'constants/Colors';
import PropTypes from 'prop-types';
import { FontWeight } from 'components/Text';

const propTypes = {
    canShow: PropTypes.bool,
    pink:PropTypes.string
  };

const Dialog = styled.div`
position: fixed; 
z-index: 5; 
padding-top: 30vh;
left: 0;
top: 0;
width: 100%; 
height: 100%; 
overflow: auto; 
background-color: rgba(255,255,255,0.4);

${({ canShow }) =>
canShow
  ? css`
      display: block;
      `
  : `display: none;`
}
`;

const DialogBody = styled.div`
  background-color: #fefefe;
  margin: auto;
  padding: 25px;
  box-shadow: 0px 1px 5px 2px ${Colors.GRAY[3]};
  width: 400px;
  height: auto;
  min-height: 100px;
  border-radius: 4px;
`;

const DialogIcon = styled.div`
    height: 30px;
    display: block;
    width: 100%;
    ${({ pink }) =>
    pink == "exclamation"
      ? css`
          color: ${Colors.PINK};
          `
      : `display: ${Colors.BLACK};`
    }
    
    font-size: 22px;
    svg{
      float: left;
    }
`;

const DialogText = styled.p`
    display: block;
    color: ${Colors.GRAY[6]};
    font-weight: ${FiraSansBold};
    font-family: 'Fira Sans', sans-serif;
    font-size: 14px;
    text-transform: uppercase;
    float: left;
    margin: 0px;
    margin-left: 8px;
    margin-top: 1px;
`;

const ContentTextarea = styled.div`
width: 100%;  
margin-top: 0px;
margin-bottom: 0px;
p{
  color: ${Colors.GRAY[0]};
  margin-bottom: 5px;
  margin-top: 10px;
  font-weight: normal;
  font-size: 14px;
}
`;

const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${Colors.GREEN};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[6]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

const TextArea = styled.textarea`
  width:100%;
  height: 120px;
  padding:15px;
  border:2px solid ${Colors.GRAY[3]};
  border-radius:8px;
  resize:none;
  font-family: Courier, monospace;
  font-weight: ${FontWeight.SemiBold};
  color: ${Colors.GRAY[6]};
  font-size:14px;
  margin-bottom: 15px;
`;

export const Message = styled.p`
  margin-bottom: 20px !important;
  margin-left: 10px;
  margin-right: 10px;
`

export {Dialog, DialogBody, DialogIcon, DialogText, ContentTextarea, DialogCancel, DialogConfirm, TextArea};



